(() => {
  const hero = document.querySelector('.legal-journal__hero');
  if (!hero) return;

  const videos = [...hero.querySelectorAll('.legal-journal__hero-video')];
  if (!videos.length) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;

  const activeVideo = () =>
    mobile.matches
      ? hero.querySelector('.legal-journal__hero-video--mobile') || hero.querySelector('.legal-journal__hero-video--desktop')
      : hero.querySelector('.legal-journal__hero-video--desktop');

  const syncPlayback = () => {
    const active = visible && !reducedMotion.matches ? activeVideo() : null;
    videos.forEach((video) => {
      if (video !== active) video.pause();
    });
    if (!active) return;
    if (active.dataset.src) {
      const source = document.createElement('source');
      source.src = active.dataset.src;
      source.type = 'video/mp4';
      active.appendChild(source);
      delete active.dataset.src;
      active.load();
    }
    active.play()?.catch?.(() => {});
  };

  videos.forEach((video) => {
    video.addEventListener('playing', () => video.classList.add('is-playing'));
    video.addEventListener('pause', () => video.classList.remove('is-playing'));
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver((entries) => {
      visible = entries.some((entry) => entry.isIntersecting);
      syncPlayback();
    }, { threshold: 0.08 }).observe(hero);
  } else {
    visible = true;
    syncPlayback();
  }

  [mobile, reducedMotion].forEach((query) => query.addEventListener?.('change', syncPlayback));
})();
